/*
 * Copyright (c) 2024 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain
 * proprietary information of OCLC, Inc. and shall not be disclosed in whole or in
 * any part to any third party or used by any person for any purpose, without written
 * consent of OCLC, Inc.  Duplication of any portion of these  materials shall include this notice.
 *
 */

import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import tokenData from '@oclc/design-system-components/design-tokens/base-tokens.json';
import { staffCompact } from '@oclc/design-system-components';

const customTheme = {
  spacing: 4,
  palette: {
    ...tokenData.tokens.palette,
  },
  typography: {
    fontFamily: tokenData.tokens.typography.fontFamily,
    h3: tokenData.tokens.typography.headingLg,
    label: tokenData.tokens.typography.label,
    labelSm: tokenData.tokens.typography.labelSm,
    labelLg: tokenData.tokens.typography.labelLg,
    button: tokenData.tokens.typography.labelSm,
    subtitle1: tokenData.tokens.typography.body,
    subtitle2: tokenData.tokens.typography.bodySm,
    body1: tokenData.tokens.typography.body,
    body2: tokenData.tokens.typography.bodySm,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          minWidth: '320px',
          overflowX: 'auto',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          ...tokenData.tokens.typography.body,
          color: tokenData.tokens.palette.blue.blue500,
          textDecorationColor: tokenData.tokens.palette.blue.blue500,
          letterSpacing: '0.005em',
          '&:hover': {
            color: tokenData.tokens.palette.blue.blue600,
            textDecorationColor: tokenData.tokens.palette.blue.blue600,
            textDecorationThickness: '2px',
          },
          '&:visited': {
            color: tokenData.tokens.palette.purple.purple500,
            textDecorationColor: tokenData.tokens.palette.purple.purple500,
          },
        },
      },
    },
  },
};

const theme = createTheme(deepmerge(staffCompact, customTheme));

export default theme;
